import React, { useState } from "react";
import { X, Sparkles } from "lucide-react";

// באנר "חינם לזמן מוגבל" — מוצג בכל האתר עד חיבור סליקה. ניתן לסגירה (נשמר ב-localStorage).
export default function FreeBanner() {
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem("free_banner_dismissed") === "1"; } catch { return false; }
  });
  if (hidden) return null;

  const dismiss = () => {
    try { localStorage.setItem("free_banner_dismissed", "1"); } catch { /* noop */ }
    setHidden(true);
  };

  return (
    <div
      className="fixed left-1/2 -translate-x-1/2 z-30 w-[92%] max-w-2xl print:hidden"
      style={{ bottom: "calc(var(--bottom-stack, 0px) + 1rem)" }}
      dir="rtl"
    >
      <div className="flex items-center gap-3 rounded-2xl gradient-primary text-white shadow-xl shadow-primary/30 px-4 py-3">
        <Sparkles className="w-5 h-5 flex-shrink-0" />
        <div className="text-sm font-medium flex-1 leading-snug">
          🎉 <strong>לזמן מוגבל — כל הפיצ'רים בחינם!</strong> עד להשקת התשלומים. הפיקו חשבוניות וקבלות ללא הגבלה.
        </div>
        <button onClick={dismiss} aria-label="סגור" className="opacity-80 hover:opacity-100 transition flex-shrink-0">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
